import React from "react";
import { Box, Flex, Text, Icon, Divider, Stack } from "@chakra-ui/react";
import { Building2, Percent, MapPin, Phone, Mail, Coins } from "lucide-react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";

const ViewCompanySettingsDrawer = ({ isOpen, onClose, company }) => {
  if (!company) return null;

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerContent={
        <Text fontSize="2xl" fontWeight="bold">
          Company Settings
        </Text>
      }
      bodyContent={
        <Flex direction="column" p={8} width="100%">
          {/* Header */}
          <Box>
            <Text fontSize="2xl" fontWeight="bold">
              {company.company_name}
            </Text>
            <Text fontSize="sm" color="gray.500" mt={1}>
              VAT Number: {company.vat_number}
            </Text>
          </Box>

          <Divider my={6} />

          <Flex direction="column" p={4}>
            <Box mb={6}>
              <Stack spacing={4}>
                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={Building2} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Company Name: {company.company_name}
                  </Text>
                </Flex>

                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={Percent} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    VAT Percentage: {company.vat_percent}%
                  </Text>
                </Flex>

                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={Coins} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Base Cost Per Delivery: BWP{company.base_cost_per_delivery}
                  </Text>
                </Flex>

                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={MapPin} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Postal Address: {company.postal_address || "N/A"}
                  </Text>
                </Flex>

                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={MapPin} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Business Address: {company.business_address || "N/A"}
                  </Text>
                </Flex>

                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={Phone} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Phone: {company.phone || "N/A"}
                  </Text>
                </Flex>

                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={Mail} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Email: {company.email || "N/A"}
                  </Text>
                </Flex>

                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={Coins} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Currency: {company.currency}
                  </Text>
                </Flex>
              </Stack>
            </Box>
          </Flex>
        </Flex>
      }
    />
  );
};

export default ViewCompanySettingsDrawer;
